/**
 * 封装localstorage, 添加可以处理对象的方法
 */
export default {
  setO(key, o, tmp = false) {
    let s = tmp ? sessionStorage : localStorage;
    s.setItem(key, JSON.stringify(o));
  },
  set(key, v, tmp = false) {
    let s = tmp ? sessionStorage : localStorage;
    s.setItem(key, v);
  },
  getO(key) {
    let s = localStorage.getItem(key) || sessionStorage.getItem(key);
    if (s) {
      return JSON.parse(s);
    }
    return null;
  },
  get(key) {
    return localStorage.getItem(key) || sessionStorage.getItem(key);
  },
  remove(key) {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  },
  clear() {
    localStorage.clear();
    sessionStorage.clear();
  }
};



// WEBPACK FOOTER //
// ./src/store/storage.js